
import Banner from './banner/Banner'
import Header from '../../ui/includes/Header'
import About from './About'
import Services from './services/Services'
import WhyChoose from './whyChoose/WhyChoose'
import Clients from './clients/Clients'
import Contact from './contact/Contact'
import Footer from '../footer/Footer'
// import Transform from './ceo/CeoMessage'
// import Projects from './projects/Projects'
// import Faqs from './faqs/Faqs'
// import Contact from './contact/Contact'
// import Footer from '../footer/Footer'



const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            <About />
            <Services />
            <WhyChoose />
            <Clients />
            <Contact />
            <Footer />
            
        </>
    )
}

export default Index
